//   $('.product_slider_card').slick({
//   arrows: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 1,
//     centerMode: true,
//         centerPadding: '300px',
//   slidesToScroll: 1,
//     prevArrow: $('.pb-prev'),
//   nextArrow: $('.pb-next'),
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//          centerMode: false,
        
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         centerMode: false,
        
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//          centerMode: false,
//   centerPadding: '0px',
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });



// $('.review_slider_card').slick({
//   arrows: true,
//   dots: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//    prevArrow: $('.bs-prev'),
//   nextArrow: $('.bs-next'),
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//          dots: false,
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//          dots: false,
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//     // You can unslick at a given breakpoint now by adding:
//     // settings: "unslick"
//     // instead of a settings object
//   ]
// });

(()=>{let s=document.getElementById('desc-short'),f=document.getElementById('desc-full'),b=document.getElementById('desc-btn'),n=250,d=new DOMParser().parseFromString(f.innerHTML,'text/html'),c=0,o=document.createElement('div');
function cut(a,z){[...a.childNodes].forEach(x=>{if(c>=n)return;if(x.nodeType===3){z.append(document.createTextNode(x.textContent.slice(0,n-c)));c+=x.textContent.length}else if(x.nodeType===1){let e=x.cloneNode(false);z.append(e);cut(x,e)}})}
cut(d.body,o);if(d.body.textContent.trim().length<=n)b.hidden=true;else s.innerHTML=o.innerHTML+'...';
b.onclick=()=>{let open=f.hidden;s.hidden=open;f.hidden=!open;b.textContent=open?'Read Less':'Read More'};
})();


